import { ContentPage, FooterPage, HeaderPage } from './components';
import { LayoutPage } from '@/components/hoc';
import { useDocumentTitle } from '@/hooks';

const HomePage = () => {

	useDocumentTitle();

	return (
		<LayoutPage>
			<HeaderPage />
			<div className='pt-3 md:pt-5'>
				<ContentPage />
				<FooterPage />
			</div>
		</LayoutPage>
	);

};

export default HomePage;
